export const report = {
  quarter: [{
    value: 1, label: '一季度'
  }, {
    value: 2, label: '二季度'
  }, {
    value: 3, label: '三季度'
  }, {
    value: 4, label: '四季度'
  }],
  branchOrgType: [{
    value: 1,
    label: '业务部门'
  }, {
    value: 2,
    label: '工号归属部门'
  }],
  includeTax: [{
    value: false,
    label: '不含税'
  }, {
    value: true,
    label: '含税'
  }]
}

export default {
  report
}



// WEBPACK FOOTER //
// ./src/data/report.js